export default "__VITE_ASSET__Ire_fpkf__"